import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import TradingOneClickV2Facet from '../abis/TradingOneClickV2Facet';
import { getContractAddress } from '../constants';

export const getTradingOneClickV2Facet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: TradingOneClickV2Facet,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
